(() => {
  // Gallery 3A + grouped 3B eager guard cache-bust: 2026-07-28.
  const TEST_PRODUCT_PATH = '/products/sun-eva-shower-curtain-liner-8g';
  const VARIANT_MEDIA_BY_VARIANT_ID = Object.freeze({
    '46715827028194': '32554508026082',
    '46853185208546': '38674128109794',
    '46853185241314': '38667737202914',
    '46715827060962': '32554508124386',
    '46853185274082': '38674128142562',
    '46853185306850': '38667690475746',
    '44580569874658': '37091628155106',
    '45817510035682': '34463890899170',
    '45817510002914': '34463890866402',
    '44580569743586': '32554508157154',
    '44580569776354': '37091705749730',
    '44580569809122': '32554508222690',
    '44580569841890': '37091689234658',
    '45817510068450': '34463890931938'
  });
  const VARIANT_MAIN_MEDIA_IDS = new Set(Object.values(VARIANT_MEDIA_BY_VARIANT_ID));
  const currentScript = document.currentScript;

  if (!currentScript?.src) return;

  const originalScriptUrl = currentScript.src.replace(
    /media-gallery\.js(?=\?|$)/,
    'media-gallery-original-test.js'
  );
  const isTestProduct = window.location.pathname.replace(/\/$/, '') === TEST_PRODUCT_PATH;
  const guardedImages = new WeakSet();
  const nativeLoading = Object.getOwnPropertyDescriptor(
    HTMLImageElement.prototype,
    'loading'
  );
  const nativeFetchPriority = Object.getOwnPropertyDescriptor(
    HTMLImageElement.prototype,
    'fetchPriority'
  );

  const isItemVisible = (item) => Boolean(item) && item.style.display !== 'none';

  const isPriorityItem = (item) => (
    Boolean(item)
    && item.matches('.media-viewer__item')
    && item.dataset.galleryLoadPriority === 'high'
    && isItemVisible(item)
  );

  const setNativeLoading = (image, value) => {
    if (nativeLoading?.set) {
      nativeLoading.set.call(image, value);
    } else {
      image.setAttribute('loading', value);
    }
  };

  const setNativeFetchPriority = (image, value) => {
    if (nativeFetchPriority?.set) {
      nativeFetchPriority.set.call(image, value);
    } else {
      image.setAttribute('fetchpriority', value);
    }
  };

  const getFetchPriority = (image) => (
    nativeFetchPriority?.get
      ? nativeFetchPriority.get.call(image)
      : image.getAttribute('fetchpriority')
  );

  const getPolicyImages = (item) => (
    item?.matches('.media-viewer__item')
      ? item.querySelectorAll('img.product-image')
      : item?.querySelectorAll('img') || []
  );

  const hydrateImage = (image) => {
    if (
      !image
      || image.dataset.galleryDeferred !== 'true'
      || image.dataset.galleryHydrated === 'true'
    ) {
      return false;
    }

    const picture = image.closest('picture');
    picture?.querySelectorAll('source[data-srcset]').forEach((source) => {
      const deferredSrcset = source.dataset.srcset;
      if (deferredSrcset && source.getAttribute('srcset') !== deferredSrcset) {
        source.setAttribute('srcset', deferredSrcset);
      }
    });

    if (image.dataset.srcset && image.getAttribute('srcset') !== image.dataset.srcset) {
      image.setAttribute('srcset', image.dataset.srcset);
    }
    if (image.dataset.src && image.getAttribute('src') !== image.dataset.src) {
      image.setAttribute('src', image.dataset.src);
    }

    image.dataset.galleryHydrated = 'true';
    return true;
  };

  const hydrateItemImages = (item) => {
    if (!item) return 0;
    return Array.from(item.querySelectorAll('img[data-gallery-deferred="true"]'))
      .reduce((count, image) => count + Number(hydrateImage(image)), 0);
  };

  const hydrateVisibleGalleryImages = (gallery, priorityItem = null) => {
    let hydratedCount = hydrateItemImages(priorityItem);

    gallery.querySelectorAll('.media-viewer__item').forEach((item) => {
      if (item !== priorityItem && isItemVisible(item)) {
        hydratedCount += hydrateItemImages(item);
      }
    });
    gallery.querySelectorAll('.media-thumbs__item').forEach((item) => {
      if (isItemVisible(item)) hydratedCount += hydrateItemImages(item);
    });

    return hydratedCount;
  };

  const guardImageLoading = (image, item) => {
    if (!nativeLoading?.get || !nativeLoading?.set || guardedImages.has(image)) return;

    guardedImages.add(image);
    Object.defineProperty(image, 'loading', {
      configurable: true,
      enumerable: true,
      get() {
        return nativeLoading.get.call(image);
      },
      set(value) {
        if (value === 'eager' && !isPriorityItem(item)) {
          nativeLoading.set.call(image, 'lazy');
          return;
        }
        nativeLoading.set.call(image, value);
      }
    });
  };

  const setItemVisibility = (item, visible) => {
    if (!item) return;
    const display = visible ? '' : 'none';
    if (item.style.display !== display) item.style.display = display;
  };

  const getMainGallery = () => document.querySelector(
    '.cc-main-product media-gallery, .product-main media-gallery'
  );

  const getVariantIdFromPage = (gallery) => {
    const section = gallery?.closest('.js-product');
    const variantInput = section?.querySelector('input[name="id"]');
    const urlVariantId = new URLSearchParams(window.location.search).get('variant');
    return urlVariantId || variantInput?.value || null;
  };

  const getInitialVariantMediaId = (gallery) => {
    const variantId = getVariantIdFromPage(gallery);
    if (variantId && VARIANT_MEDIA_BY_VARIANT_ID[variantId]) {
      return VARIANT_MEDIA_BY_VARIANT_ID[variantId];
    }
    return gallery?.querySelector('.media-viewer__item.is-current-variant')?.dataset.mediaId || null;
  };

  const getVariantMediaIdFromEvent = (event) => {
    const variantId = String(event.detail?.variant?.id || '');
    const featuredMediaId = event.detail?.variant?.featured_media?.id;
    if (featuredMediaId && VARIANT_MAIN_MEDIA_IDS.has(String(featuredMediaId))) {
      return String(featuredMediaId);
    }
    return VARIANT_MEDIA_BY_VARIANT_ID[variantId] || null;
  };

  const primePriorityItem = (gallery, item) => {
    if (!item) return;

    gallery.querySelectorAll('.media-viewer__item').forEach((viewerItem) => {
      if (viewerItem === item) {
        viewerItem.dataset.galleryLoadPriority = 'high';
      } else {
        delete viewerItem.dataset.galleryLoadPriority;
      }
    });

    getPolicyImages(item).forEach((image) => {
      guardImageLoading(image, item);
      setNativeLoading(image, 'eager');
      setNativeFetchPriority(image, 'high');
      image.dataset.galleryLoadingPolicy = 'eager-high';
    });
    hydrateItemImages(item);
    gallery.dataset.priorityMediaId = item.dataset.mediaId || '';
  };

  const applyGalleryImagePriorities = (gallery, preferredItem = null) => {
    const viewerItems = Array.from(gallery.querySelectorAll('.media-viewer__item'));
    const priorityItem = (
      preferredItem
      && viewerItems.includes(preferredItem)
      && isItemVisible(preferredItem)
    )
      ? preferredItem
      : viewerItems.find(
        (item) => item.classList.contains('is-current-variant') && isItemVisible(item)
      ) || viewerItems.find(isItemVisible) || null;

    hydrateVisibleGalleryImages(gallery, priorityItem);

    viewerItems.forEach((item) => {
      if (item === priorityItem) {
        item.dataset.galleryLoadPriority = 'high';
      } else {
        delete item.dataset.galleryLoadPriority;
      }
    });

    gallery.querySelectorAll('.media-viewer__item, .media-thumbs__item').forEach((item) => {
      const highPriority = item === priorityItem;

      getPolicyImages(item).forEach((image) => {
        guardImageLoading(image, item);
        setNativeLoading(image, highPriority ? 'eager' : 'lazy');
        setNativeFetchPriority(image, highPriority ? 'high' : 'low');
        image.dataset.galleryLoadingPolicy = highPriority ? 'eager-high' : 'lazy-low';
      });
    });

    gallery.dataset.priorityMediaId = priorityItem?.dataset.mediaId || '';
    return priorityItem;
  };

  const moveBeforeFirstVisible = (item, container) => {
    if (!item || !container) return;
    const firstVisible = Array.from(container.children).find(
      (child) => child !== item && isItemVisible(child)
    );
    if (firstVisible && Array.from(container.children).find(isItemVisible) !== item) {
      container.insertBefore(item, firstVisible);
    }
  };

  const applyVariantMainRules = (gallery, selectedMediaId) => {
    if (!selectedMediaId || !VARIANT_MAIN_MEDIA_IDS.has(String(selectedMediaId))) return null;

    const selectedId = String(selectedMediaId);
    const viewer = gallery.querySelector('.media-viewer');
    const thumbs = gallery.querySelector('.media-thumbs');
    let selectedMain = null;
    let selectedThumb = null;

    gallery.querySelectorAll('.media-viewer__item').forEach((item) => {
      const mediaId = String(item.dataset.mediaId || '');
      if (!VARIANT_MAIN_MEDIA_IDS.has(mediaId)) return;

      const active = mediaId === selectedId;
      setItemVisibility(item, active);
      item.classList.toggle('is-current-variant', active);
      item.dataset.sizeVariantMain = active ? 'active' : 'inactive';
      if (active) selectedMain = item;
    });

    gallery.querySelectorAll('.media-thumbs__item').forEach((item) => {
      const mediaId = String(item.dataset.mediaId || '');
      if (!VARIANT_MAIN_MEDIA_IDS.has(mediaId)) return;

      const active = mediaId === selectedId;
      setItemVisibility(item, active);
      item.dataset.sizeVariantMain = active ? 'active' : 'inactive';
      if (active) selectedThumb = item;
    });

    moveBeforeFirstVisible(selectedMain, viewer);
    moveBeforeFirstVisible(selectedThumb, thumbs);
    return selectedMain;
  };

  const rebuildVisibleItems = (gallery) => {
    if (typeof gallery.setVisibleItems === 'function') {
      gallery.setVisibleItems();
    } else {
      gallery.visibleItems = Array.from(
        gallery.querySelectorAll('.media-viewer__item')
      ).filter(isItemVisible);
    }

    const visibleItems = Array.from(gallery.visibleItems || []).filter(isItemVisible);
    gallery.visibleItems = visibleItems;

    if (visibleItems.length > 1) {
      gallery.viewerItemOffset = visibleItems[1].offsetLeft - visibleItems[0].offsetLeft;
    }
    return visibleItems;
  };

  const refreshGalleryState = (gallery, preferredItem = null, resetToFirst = false) => {
    const visibleItems = rebuildVisibleItems(gallery);
    if (visibleItems.length === 0) return;

    let currentItem = preferredItem && visibleItems.includes(preferredItem)
      ? preferredItem
      : gallery.currentItem;

    if (!currentItem || !visibleItems.includes(currentItem)) {
      currentItem = visibleItems[0];
    }

    const selectedVariantMain = visibleItems.find(
      (item) => item.classList.contains('is-current-variant')
    ) || null;
    hydrateVisibleGalleryImages(gallery, selectedVariantMain || currentItem);

    gallery.currentItem = currentItem;
    gallery.currentIndex = visibleItems.indexOf(currentItem);

    if (resetToFirst && gallery.viewer) {
      gallery.viewer.scrollTo({ left: currentItem.offsetLeft, behavior: 'auto' });
    }

    if (gallery.counterCurrent) {
      gallery.counterCurrent.textContent = String(gallery.currentIndex + 1);
    }
    if (gallery.counterTotal) {
      gallery.counterTotal.textContent = String(visibleItems.length);
    }
    if (gallery.prevBtn) {
      gallery.prevBtn.disabled = gallery.currentIndex === 0;
    }
    if (gallery.nextBtn) {
      gallery.nextBtn.disabled = gallery.currentIndex === visibleItems.length - 1;
    }

    if (gallery.thumbs) {
      const currentThumb = gallery.thumbs.querySelector(
        `[data-media-id="${currentItem.dataset.mediaId}"]`
      );
      if (currentThumb && typeof gallery.setActiveThumb === 'function') {
        gallery.currentThumb = currentThumb;
        gallery.setActiveThumb();
      }
    }

    applyGalleryImagePriorities(gallery, selectedVariantMain || currentItem);
    gallery.dataset.visibleMediaCount = String(visibleItems.length);
  };

  const prepareTestGallery = () => {
    if (!isTestProduct) return null;
    const gallery = getMainGallery();
    if (!gallery) return null;

    gallery.dataset.rainColorGalleryTest = 'pending';
    const currentMediaId = getInitialVariantMediaId(gallery);

    gallery.querySelectorAll('.media-viewer__item').forEach((item) => {
      if (currentMediaId && item.dataset.mediaId !== currentMediaId) {
        item.style.display = 'none';
      }
    });
    gallery.querySelectorAll('.media-thumbs__item').forEach((item) => {
      if (currentMediaId && item.dataset.mediaId !== currentMediaId) {
        item.style.display = 'none';
      }
    });

    const priorityItem = currentMediaId
      ? gallery.querySelector(`.media-viewer__item[data-media-id="${currentMediaId}"]`)
      : gallery.querySelector('.media-viewer__item.is-current-variant');

    applyGalleryImagePriorities(gallery, priorityItem);
    return gallery;
  };

  const preparedGallery = prepareTestGallery();
  const originalScript = document.createElement('script');
  originalScript.src = originalScriptUrl;
  originalScript.async = false;

  originalScript.addEventListener('load', () => {
    if (!isTestProduct) return;

    customElements.whenDefined('media-gallery').then(() => {
      const gallery = preparedGallery || getMainGallery();
      if (!gallery || gallery.dataset.rainSizeMainTest === 'active') return;

      const section = gallery.closest('.js-product');
      const nativeCustomSetActiveMedia = gallery.customSetActiveMedia.bind(gallery);
      let selectedVariantMediaId = getInitialVariantMediaId(gallery);
      let pendingVariantMediaId = null;
      let syncQueued = false;
      let activateSelectedOnSync = true;

      document.addEventListener('on:variant:change', (event) => {
        if (!section || !section.contains(event.target)) return;

        const nextMediaId = getVariantMediaIdFromEvent(event);
        if (!nextMediaId) return;

        pendingVariantMediaId = nextMediaId;
        selectedVariantMediaId = nextMediaId;
        const nextItem = gallery.querySelector(
          `.media-viewer__item[data-media-id="${nextMediaId}"]`
        );
        primePriorityItem(gallery, nextItem);
      }, true);

      gallery.customSetActiveMedia = (mediaItem, scrollToItem = true) => {
        const mediaId = String(mediaItem?.dataset.mediaId || '');
        const isVariantMain = VARIANT_MAIN_MEDIA_IDS.has(mediaId);

        if (isVariantMain && (!pendingVariantMediaId || pendingVariantMediaId === mediaId)) {
          selectedVariantMediaId = mediaId;
          if (pendingVariantMediaId === mediaId) pendingVariantMediaId = null;
        }

        const selectedMain = applyVariantMainRules(gallery, selectedVariantMediaId);
        primePriorityItem(gallery, selectedMain);
        rebuildVisibleItems(gallery);

        const target = mediaItem && isItemVisible(mediaItem)
          ? mediaItem
          : selectedMain || gallery.visibleItems?.[0];
        if (!target) return undefined;

        hydrateItemImages(target);
        const result = nativeCustomSetActiveMedia(
          target,
          isVariantMain ? false : scrollToItem
        );

        refreshGalleryState(gallery, target, isVariantMain);
        return result;
      };

      const syncGallery = () => {
        syncQueued = false;
        const selectedMain = applyVariantMainRules(gallery, selectedVariantMediaId);
        refreshGalleryState(
          gallery,
          activateSelectedOnSync ? selectedMain : null,
          activateSelectedOnSync
        );
        activateSelectedOnSync = false;
        gallery.dataset.rainColorGalleryTest = 'active';
        gallery.dataset.rainSizeMainTest = 'active';
        gallery.dataset.galleryLoadingTest = '2a-active';
      };

      const queueSync = (activateSelected = false) => {
        activateSelectedOnSync = activateSelectedOnSync || activateSelected;
        if (syncQueued) return;
        syncQueued = true;
        requestAnimationFrame(() => requestAnimationFrame(syncGallery));
      };

      const bindGalleryInteractions = () => {
        if (gallery.dataset.rainGalleryInteractions === 'active') return;

        gallery.controls?.addEventListener('click', (event) => {
          const button = event.target.closest?.('.media-ctrl__btn');
          if (!button || !gallery.controls.contains(button)) return;

          const visibleItems = rebuildVisibleItems(gallery);
          const displayedIndex = Math.max(
            0,
            Number.parseInt(gallery.counterCurrent?.textContent || '1', 10) - 1
          );
          const targetIndex = button === gallery.nextBtn
            ? displayedIndex + 1
            : displayedIndex - 1;
          const target = visibleItems[targetIndex];
          if (target) gallery.customSetActiveMedia(target, true);
        });

        gallery.thumbs?.addEventListener('click', (event) => {
          const thumb = event.target.closest?.('.media-thumbs__item[data-media-id]');
          if (!thumb || !gallery.thumbs.contains(thumb)) return;

          const target = gallery.querySelector(
            `.media-viewer__item[data-media-id="${thumb.dataset.mediaId}"]`
          );
          if (!target || !isItemVisible(target)) return;

          gallery.customSetActiveMedia(target, true);
          customElements.get('media-gallery')?.playActiveMedia?.(target);
        });

        let scrollSyncQueued = false;
        gallery.viewer?.addEventListener('scroll', () => {
          if (scrollSyncQueued) return;
          scrollSyncQueued = true;
          requestAnimationFrame(() => {
            scrollSyncQueued = false;
            const visibleItems = rebuildVisibleItems(gallery);
            if (visibleItems.length === 0) return;

            const currentIndex = Math.max(
              0,
              Number.parseInt(gallery.counterCurrent?.textContent || '1', 10) - 1
            );
            const nearestItem = visibleItems.reduce((nearest, item) => (
              Math.abs(item.offsetLeft - gallery.viewer.scrollLeft)
                < Math.abs(nearest.offsetLeft - gallery.viewer.scrollLeft)
                ? item
                : nearest
            ));
            const nearestIndex = visibleItems.indexOf(nearestItem);
            if (nearestIndex !== currentIndex) {
              gallery.customSetActiveMedia(nearestItem, false);
            }
          });
        });

        window.addEventListener('on:debounced-resize', () => queueSync(false));
        gallery.dataset.rainGalleryInteractions = 'active';
      };

      bindGalleryInteractions();

      const observer = new MutationObserver((mutations) => {
        if (mutations.some((mutation) => mutation.attributeName === 'style')) {
          queueSync(false);
        }
      });

      observer.observe(gallery, {
        subtree: true,
        attributes: true,
        attributeFilter: ['style']
      });

      section?.addEventListener('on:variant:change', (event) => {
        const nextMediaId = getVariantMediaIdFromEvent(event);
        if (nextMediaId) selectedVariantMediaId = nextMediaId;
        queueSync(true);
      });

      document.addEventListener('shopify:section:load', () => queueSync(true));

      window.__amazerBathRainGalleryTest = {
        gallery,
        sync: () => queueSync(true),
        state() {
          const visibleItems = Array.from(
            gallery.querySelectorAll('.media-viewer__item')
          ).filter(isItemVisible);
          const images = Array.from(
            gallery.querySelectorAll('.media-viewer__item img, .media-thumbs__item img')
          );

          return {
            path: window.location.pathname,
            selectedVariantMediaId,
            visibleMediaCount: visibleItems.length,
            visibleMediaIds: visibleItems.map((item) => item.dataset.mediaId),
            visibleVariantMainIds: visibleItems
              .filter((item) => VARIANT_MAIN_MEDIA_IDS.has(String(item.dataset.mediaId)))
              .map((item) => item.dataset.mediaId),
            currentMediaId: gallery.currentItem?.dataset.mediaId || null,
            currentIndex: gallery.currentIndex,
            priorityMediaId: gallery.dataset.priorityMediaId || null,
            eagerImageCount: images.filter((image) => image.loading === 'eager').length,
            lazyImageCount: images.filter((image) => image.loading === 'lazy').length,
            highPriorityImageCount: images.filter(
              (image) => getFetchPriority(image) === 'high'
            ).length,
            lowPriorityImageCount: images.filter(
              (image) => getFetchPriority(image) === 'low'
            ).length,
            deferredImageCount: images.filter(
              (image) => image.dataset.galleryDeferred === 'true'
            ).length,
            hydratedDeferredImageCount: images.filter(
              (image) => image.dataset.galleryHydrated === 'true'
            ).length
          };
        }
      };

      queueSync(true);
    });
  });

  originalScript.addEventListener('error', () => {
    console.error('[Rain gallery test] Failed to load the original media gallery script.');
  });

  document.head.appendChild(originalScript);
})();
